import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsAccountTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['account']> = {
  zh: {
    lockedHeroTitleLine1: '简单可靠的',
    lockedHeroTitleLine2: '海外仓一件代发服务',
    lockedSocialProof: '1000+ 跨境卖家的选择',
    actionOpenAccount: '立即开户',
    actionContactService: '咨询客服',
    customerServiceLinkText: '联系海海客服',
    cardOmsTitle: '你的 OMS',
    cardOmsDescription: '使用领星 OMS 管理你的一件代发库存和订单。',
    actionLoginOms: '登录 OMS',
    fieldAccount: '账号',
    fieldInitialPassword: '初始密码',
    textNotSet: '未设置',
    sectionPaymentMethod: '充值方式',
    paymentOnlineTitle: '在线支付（推荐）',
    paymentOnlineDescription: '支持任何币种，实时到账。',
    actionPayNow: '立即支付',
    paymentBankUsdTitle: '银行转账 · 美元',
    paymentBankUsdDescription: '从空中云汇、万里汇、派安盈转账无手续费，从中国内地银行转账每笔15~30美元手续费。',
    paymentBankCnyTitle: '银行转账 · 人民币',
    paymentBankCnyDescription: '充值审核时按实际汇率进行换汇，并额外扣除3%换汇手续费。',
    actionCheckRate: '查询实时汇率',
    sectionAfterDeposit: '充值后的操作',
    submitDepositTitle: '提交充值单',
    submitDepositDescriptionLocked: '付款后，请联系海海客服，按照以下要求提交充值单完成开户。',
    submitDepositDescriptionUnlocked: '付款后，请按照以下要求提交充值单，审核通过后方可使用。',
    actionSubmitDeposit: '提交充值单',
    actionUrgeReview: '催促审核',
    itemPaymentMethod: '付款方式：选择**银行转帐**',
    itemAmount: '充值金额：按**美元**金额填写',
    itemCurrency: '充值币种：选择**$**',
    itemVoucher: '充值凭证：上传**付款成功截图**',
    lockedDepositTitle: '充值开通一件代发账户',
    unlockedDepositTitle: '充值至 OMS',
    depositDescription: '任选一种方式付款，完成后在 OMS 中提交充值单。',
    lockedDepositNote: '服务费用均从 OMS 余额中扣除。',
    unlockedDepositNote: '国际物流、海外仓、海外快递的各项费用均从 OMS 中扣除，请确保余额在100美元以上，且每次充值金额不少于100美元。',
    pricingPlanProTitle: '专业卖家',
    pricingPlanProDescription: '完整的一件代发服务、最低折扣面单和店铺申诉协助。',
    pricingPlanStarterTitle: '新手卖家',
    pricingPlanStarterDescription: '完整的一件代发服务。',
    pricingPlanFirstTopupUnit: '首次充值',
    planFeatureOms: '订单管理系统',
    planFeatureFullDropshipping: '完整的一件代发服务',
    planFeatureSupport: '中美双时区客服支持',
    planFeatureUnlimitedQuote: '不限量的一件代发成本试算',
    planFeatureDiscount30: '最低3折购买USPS等6种正规快递面单',
    planFeatureAppealMaterials: '用于店铺申诉的海外仓资质',
    planFeatureQuote50: '每月50次一件代发成本试算',
    planFeatureDiscount40: '最低4折购买USPS等6种正规快递面单',
    bankUsdNameLabel: 'Name',
    bankUsdAccountNumberLabel: 'Account number',
    bankUsdAbaLabel: 'ABA Routing number',
    bankUsdSwiftLabel: 'SWIFT code',
    bankUsdBankNameLabel: 'Bank Name',
    bankUsdBankAddressLabel: 'Bank Address',
    bankCnyAccountNameLabel: '账户名称',
    bankCnyAccountNumberLabel: '账户号码',
    bankCnyBankLabel: '开户银行',
  },
  en: {
    lockedHeroTitleLine1: 'Reliable and simple',
    lockedHeroTitleLine2: 'overseas warehouse dropshipping',
    lockedSocialProof: 'Trusted by 1,000+ cross-border sellers',
    actionOpenAccount: 'Open account',
    actionContactService: 'Contact support',
    customerServiceLinkText: 'Contact SSEEAA support',
    cardOmsTitle: 'Your OMS',
    cardOmsDescription: 'Use Lingxing OMS to manage your dropshipping inventory and orders.',
    actionLoginOms: 'Log in to OMS',
    fieldAccount: 'Account',
    fieldInitialPassword: 'Initial password',
    textNotSet: 'Not set',
    sectionPaymentMethod: 'Top-up methods',
    paymentOnlineTitle: 'Online payment (recommended)',
    paymentOnlineDescription: 'Supports all currencies with real-time balance arrival.',
    actionPayNow: 'Pay now',
    paymentBankUsdTitle: 'Bank transfer · $',
    paymentBankUsdDescription: 'No fee from Airwallex/WorldFirst/Payoneer; mainland China bank transfers usually incur a $15-30 fee per transfer.',
    paymentBankCnyTitle: 'Bank transfer · ¥',
    paymentBankCnyDescription: 'During review, funds are converted at actual exchange rate plus an extra 3% conversion fee.',
    actionCheckRate: 'Check live rates',
    sectionAfterDeposit: 'After payment',
    submitDepositTitle: 'Submit top-up request',
    submitDepositDescriptionLocked: 'After payment, contact SSEEAA support and submit a top-up request with the requirements below to complete onboarding.',
    submitDepositDescriptionUnlocked: 'After payment, submit a top-up request with the requirements below. Service activates after approval.',
    actionSubmitDeposit: 'Submit top-up request',
    actionUrgeReview: 'Follow up review',
    itemPaymentMethod: 'Payment method: select **Bank transfer**',
    itemAmount: 'Top-up amount: fill in **$** amount',
    itemCurrency: 'Currency: select **$**',
    itemVoucher: 'Voucher: upload **successful payment screenshot**',
    lockedDepositTitle: 'Top up to activate dropshipping account',
    unlockedDepositTitle: 'Top up OMS balance',
    depositDescription: 'Choose any method above, then submit the top-up request in OMS.',
    lockedDepositNote: 'All service fees are deducted from OMS balance.',
    unlockedDepositNote: 'International logistics, warehouse, and local-delivery fees are deducted from OMS. Keep balance above $100 and each top-up no less than $100.',
    pricingPlanProTitle: 'Pro seller',
    pricingPlanProDescription: 'Full dropshipping service, best label discounts, and store appeal assistance.',
    pricingPlanStarterTitle: 'Starter seller',
    pricingPlanStarterDescription: 'Full dropshipping service.',
    pricingPlanFirstTopupUnit: 'first top-up',
    planFeatureOms: 'Order management system',
    planFeatureFullDropshipping: 'Full dropshipping service',
    planFeatureSupport: 'CN-US dual-timezone support',
    planFeatureUnlimitedQuote: 'Unlimited dropshipping cost estimates',
    planFeatureDiscount30: 'Up to 70% off USPS and 6 compliant carrier labels',
    planFeatureAppealMaterials: 'Overseas warehouse credentials for store appeals',
    planFeatureQuote50: '50 dropshipping cost estimates per month',
    planFeatureDiscount40: 'Up to 60% off USPS and 6 compliant carrier labels',
    bankUsdNameLabel: 'Name',
    bankUsdAccountNumberLabel: 'Account number',
    bankUsdAbaLabel: 'ABA Routing number',
    bankUsdSwiftLabel: 'SWIFT code',
    bankUsdBankNameLabel: 'Bank name',
    bankUsdBankAddressLabel: 'Bank address',
    bankCnyAccountNameLabel: 'Account name',
    bankCnyAccountNumberLabel: 'Account number',
    bankCnyBankLabel: 'Bank',
  },
};
